module.exports = __webpack_public_path__ + "img/empty_01.37b5a30e.png";